import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Icon, Table, Card, Input, Button, Popup} from 'semantic-ui-react';
import moment from 'moment';
import {Actions} from '../../../../common/actions';
import {paths} from '../../../../common/dictionaries/urls';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {dayClassification, pickingOrderClassification} from '../../../../common/dictionaries/classification';
import {fullHourFormat, hourFormat} from '../../../../common/constants/datesFormat';

class ShiftsList extends Component {
  constructor(props) {
    super(props);
    this.onFilterChange = this.onFilterChange.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingShifts,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.changeShiftsTextFilter('');
    this.props.fetchShiftsList();
  }

  onFilterChange(event) {
    this.props.changeShiftsTextFilter(event.target.value);
    this.props.filterShifts(event.target.value);
  }

  parseDays(days) {
    return days
      .map((item) => {
        return dayClassification[item];
      })
      .join(', ');
  }

  parseOrderTypes(orders) {
    return orders
      .map((item) => {
        return pickingOrderClassification[item];
      })
      .join(', ');
  }

  renderCreateButton() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingShifts,
        scopes.Create
      )
    ) {
      return null;
    }

    return (
      <Button
        primary
        className='toyota-primary'
        as={Link}
        to='/picking/cortes/nuevo'
      >
        Nuevo Corte
      </Button>
    );
  }

  renderActionsCell(element) {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingShifts,
        scopes.Edit
      )
    ) {
      return null;
    }

    return (
      <Table.Cell textAlign='center'>
        <Popup
          trigger={
            <Link to={`/picking/cortes/editar/${element.code}`}>
              <Icon name='write' color='blue' size='large' />
            </Link>
          }
          content='Editar'
          position='top center'
          inverted
        />
      </Table.Cell>
    );
  }

  renderShifts(list) {
    return list.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.name}</Table.Cell>
          <Table.Cell textAlign='center'>
            {this.parseOrderTypes(element.orders)}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {moment(element.labelsEmissionTime, fullHourFormat).format(
              hourFormat
            )}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {moment(element.dispatchTime, fullHourFormat).format(hourFormat)}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {this.parseDays(element.days)}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {element.status ? 'Activo' : 'Inactivo'}
          </Table.Cell>
          {this.renderActionsCell(element)}
        </Table.Row>
      );
    });
  }

  renderActionsHeader() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingShifts,
        scopes.Edit
      )
    ) {
      return null;
    }

    return <Table.HeaderCell textAlign='center'>Acciones</Table.HeaderCell>;
  }

  render() {
    const {shifts, filterText} = this.props;
    return (
      <div className='shifts-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Mantenimiento de Cortes</h2>
              <div className='title-bar-actions'>
                <Input
                  icon='search'
                  placeholder='Buscar'
                  value={filterText}
                  onChange={this.onFilterChange}
                />
                {this.renderCreateButton()}
              </div>
            </div>
          </div>
        </Card>

        <Card fluid raised>
          <Table striped className='toyota-grid'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>Nombre</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Tipos de pedido a los que aplica
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Hora de emisión
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Hora de despacho
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Días a los que aplica
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Estado</Table.HeaderCell>
                {this.renderActionsHeader()}
              </Table.Row>
            </Table.Header>

            <Table.Body>{this.renderShifts(shifts)}</Table.Body>
          </Table>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'shifts': state.shifts.filteredList,
    'filterText': state.shifts.filterText,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  fetchShiftsList,
  filterShifts,
  changeShiftsTextFilter,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  fetchShiftsList,
  filterShifts,
  changeShiftsTextFilter,
  navigateTo,
})(ShiftsList);
